//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "product-image-viewer",
  props: {
    images:{
      type: Array,
      required: true,
      default: () => []
    },
    lightColor:{
      type: String,
      required: true,
    }
  },
  data(){
    return{
      selectedImage: "",
      imageToShow: "",
      modelForSlider: 0
    }
  },
  methods:{
    setImage(image){
      this.selectedImage = image;
      this.imageToShow = image;
    },
    previewImage(image){
      this.imageToShow = image;
    },
    loadBackOriginal(){
      this.imageToShow = this.selectedImage;
    }
  },
  watch:{
    images(){
      if(this.images && this.images.length > 0){
        this.imageToShow = this.images[0];
        this.selectedImage = this.images[0];
      }
    }
  }
}
